module.exports = __webpack_public_path__ + "img/user-folder.0e053913.png";